import { HttpBackend } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class VisitsCallsTargetsCfg {
  public summaryEndpointPattern: string;
}

export class VisitsCallsTargetsKpiCfg {
  public visitsCallsTargets: VisitsCallsTargetsCfg;
}

@Injectable()
export class VisitsCallsTargetsKpiCfgService extends CfgService<VisitsCallsTargetsKpiCfg> {
  json: any = {
    visitsCallsTargets: {
      summaryEndpointPattern: "%{DashboardApiUrl}/visitscalltargets/{0}"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/visitsCallsTargetsKpi.cfg.json`;
  }

  /**
* Carga las url en el json
*/
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
